import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.16.1_@biomejs+biome@2.0.0-beta.1_@parcel+watcher@2.5.1_@types+node@22.15.29_db0@0.3.1__hr6h5ovn4u55fmonr42sn7bhtm/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}